import styled from 'styled-components';

const SocialWrapper = styled.div<{ color?: string }>`
  font-weight: 500;
  font-size: 15px;
  line-height: 20px;
  width: 100%;
  height: 44px;
  background: ${({ color, theme }) => color || theme.colors.error500};
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 16px;
  p {
    color: #fff;
    margin-left: 15px;
  }
  @media (max-width: 260px) {
    font-size: 12px;
  }
`;

interface SocialButtonType {
  text: string;
  color?: string;
  icon: any;
  onHandleLogin: any;
}

export const SocialButton = ({
  text,
  color,
  icon,
  onHandleLogin
}: SocialButtonType) => (
  <SocialWrapper color={color} onClick={onHandleLogin}>
    <img src={icon} alt='' />
    <p>{text}</p>
  </SocialWrapper>
);
